import { createSelector } from '@ngrx/store';

import type { BreadcrumbState, NdtFileManagerState } from '@app/store/reducers';
import { getFileManagerState } from '@app/store/reducers';

/**
 * General Breadcrumb State selector
 */
export const getBreadcrumbState: any = createSelector(
  getFileManagerState,
  (state: NdtFileManagerState) => !!state && state.breadcrumb,
);

export const getBreadcrumb: any = createSelector(
  getBreadcrumbState,
  (state: BreadcrumbState) => !!state && state.value,
);

export const isBreadcrumbLoading: any = createSelector(
  getBreadcrumbState,
  (state: BreadcrumbState) => !!state && state.loading,
);
